import { TableRowProps, InnerRowItemData } from './type';
import { getUniqueKey } from '../../../utils';
import { TableRowContainerStyled, TableRowCellBaseStyled } from './styled';

const TableRow = <T,>({ ...props }: TableRowProps<T>) => {
  const { data, items, style, getRowItemCell, ...rest } = props;

  return (
    <TableRowContainerStyled {...rest}>
      {Object.values(items).map(({ value, width }: InnerRowItemData) => {
        return (
          <TableRowCellBaseStyled key={getUniqueKey()} width={width} style={{ ...style }}>
            {getRowItemCell ? getRowItemCell(value, data as T) : null}
          </TableRowCellBaseStyled>
        );
      })}
    </TableRowContainerStyled>
  );
};

TableRow.defaultProps = {
  items: {},
  style: {},
};

export default TableRow;
